import { Menu, MenuItem, Position } from "@blueprintjs/core"
import CustomDialog from "components/Atoms/CustomDialog"
import CustomPopover from "components/Atoms/CustomPopover"
import CustomTag from "components/Atoms/CustomTag"
import CustomTooltip from "components/Atoms/CustomTooltip"
import CustomOverflowList from "components/Molecules/CustomOverflowList"
import dayjs from "dayjs"
import React, { useState } from "react"

const ImageStack = ({ photos }) => {
  const [preview, setPreview] = useState(null)

  return (
    <>
      <CustomOverflowList
        // Filter out all the photos that do not have a url
        items={photos.filter(p => p?.url) ?? []}
        overflowRenderer={(photos: any) => {
          //
          return (
            <CustomPopover
              minimal
              position={Position.BOTTOM_LEFT}
              key={photos?.length}
              content={
                <Menu className="vt-overflow-list-menu">
                  {photos?.map(photo => {
                    return (
                      <MenuItem
                        onClick={e => setPreview(photo)}
                        icon={
                          // eslint-disable-next-line jsx-a11y/img-redundant-alt
                          <img
                            alt={photo?.id}
                            key={photo?.id}
                            src={photo?.url}
                            className="vt-horizontal-stack"
                          />
                        }
                        key={photo?.id}
                        text={dayjs(photo?.createdAt).format(
                          "Do MMMM YYYY, h:mm A"
                        )}
                      />
                    )
                  })}
                </Menu>
              }
            >
              <CustomTag
                key={"vt-total-tag"}
                className="ml-3"
                interactive
                round
                large
                intent="primary"
                minimal
              >
                + {photos?.length}
              </CustomTag>
            </CustomPopover>
          )
        }}
        visibleItemRenderer={(item: any) => {
          //
          return (
            <CustomTooltip
              light
              key={item?.id}
              content={
                <img
                  alt={item?.id}
                  key={item?.id}
                  src={item?.url}
                  className="vt-tooltip"
                />
              }
            >
              <img
                alt={item?.id}
                onClick={e => setPreview(item)}
                key={item?.id}
                src={item?.url}
                width="30px"
                height="30px"
                className="vt-horizontal-stack"
              />
            </CustomTooltip>
          )
        }}
      />
      <CustomDialog
        width="50%"
        style={{
          height: "80vh",
        }}
        icon="camera"
        scrollable={false}
        isOpen={preview?.url ? true : false}
        onClose={e => setPreview(null)}
        title={
          <>
            <span className="vt-muted">Uploaded At - </span>
            {dayjs(preview?.createdAt).format("Do MMMM YYYY, h:mm A")}
          </>
        }
        light
      >
        <img
          alt={preview?.id}
          className="max-w-full h-auto"
          src={preview?.url}
        />
      </CustomDialog>
    </>
  )
}

export default ImageStack
